export enum SchemaFieldType {
  BOOLEAN = 'boolean',
  DATE = 'date',
  FLOAT = 'float',
  INTEGER = 'integer',
  LIST = 'list',
  NUMERIC = 'numeric',
  STRING = 'string',
}
